import React, { Component } from "react"
import { connect } from 'react-redux'
import {Storage,MessageText} from '../../configs'
import { msg } from "../Notifications/MsgBox"
import { startLoadingAction, stopLoadingAction } from "../../redux/actions/AppAction"


class RejectModal extends Component {

    constructor(props) {
        super(props)

        this.state = {
            ...props,
            comment: null
        }
       
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        })
    }
    

   async handleReject()
    {
        await this.props.startLoading()
        const user=Storage.getUser()
      
        console.log("reject save");
        console.log("Reject_Result: " + this.state.comment);
        console.log("Reject_By: " + user.userName);

        if (this.state.comment) {
            window.$('#RejectModal').modal('hide');
            this.props.onHandleReject(this.state.comment, user.userName);
        }
        else {
            msg.error(`กรุณาระบุเหตุผลส่งกลับแก้ไข`)
            this.props.stopLoading()
            return
        }   

    }

    render() {
        console.log("RejectModal.render()")
        return (
            <div className="modal fade sp-modal rrs-modal" id="RejectModal" tabIndex={-1} role="dialog" aria-labelledby="RejectModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header bg">
                            <h5 className="modal-title" id="RejectModalLabel">Reject</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body rrs-container">

                            <div className="rrs-detail3">
                                <div className="row">
                                    <div className="rrs-form">
                                        <label htmlFor="a3" className="rrs-label"><span className="required">*</span> หมายเหตุ</label>
                                        <div className="rrs-detail-data">
                                        <textarea cols="100" rows="50" maxLength="1000" className="form-control rrs-textarea" name="comment" onChange={this.handleChange}></textarea>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mx-0 header-button-row mt-5">
                                    <div className="col-12 sp-header-button-panel2">
                                        <a href="#main" className="sp-btn-icon sp-btn-gray" onClick={(event) => { this.handleReject() }}>
                                            <i className="icon btn-order-check-green" />
                                            <span className="sp-btn-icon-label3">{MessageText.APP.MSG_BOX_BUTTON_TEXT_YES}</span>
                                        </a>
                                        <a href="#" className="sp-btn-icon sp-btn-gray" data-dismiss="modal" aria-label="Close">
                                            <i className="icon btn-cancel" />
                                            <span className="sp-btn-icon-label2">{MessageText.APP.MSG_BOX_BUTTON_TEXT_NO}</span>
                                        </a>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
      
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
        startLoading: () => dispatch(startLoadingAction()),
        stopLoading: () => dispatch(stopLoadingAction()),
    }
  }
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(RejectModal)